module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.f36638c2.ttf";